import { render } from "./Dependencies.vue?vue&type=template&id=611b95c0"
import script from "./Dependencies.vue?vue&type=script&lang=js"
export * from "./Dependencies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__